module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "image2"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/035imagecredits#page8",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-8.jpg"
    }
  })])])]), _vm._v(" "), _c('h1', [_vm._v("EPIGRAPH")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("“A bat! That’s it! It’s an omen!”"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Bruce Wayne, 1939")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Michael Uslan, 1959, age 8")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415acfa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005epigraph.vue
// module id = 69
// module chunks = 0